import React from "react";
import { useAppDispatch, useAppSelector } from "@/store/store";
import { useHistory } from "react-router-dom";
import { useIntl } from "react-intl";
import { makeStyles } from "@mui/styles";
import AppBar from "./../../components/DefaultAppBar";
import { logoutUser } from "./../../modules/user/userActions";
import UpdatePasswordContainer from "./../../containers/UpdatePasswordContainer/UpdatePasswordContainer";
import ProfileHeader from "./ProfileHeader";
import SimpleProfile from "./SimpleProfile";
import { Link } from "react-router-dom";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import bg from "../../assets/hausify-logo-app.jpg";
import LocationFilterToolbar from "../../App/LocationFilterToolbar";
import Paper from "@mui/material/Paper";

export const route = "/profile";

const profileContent = [
  {
    primary: "Kontakt zu Ihrer Verwaltung",
    i18Id: "profile.link.property_management",
    to: "/property-management",
  },
  {
    primary: "Benachrichtigungseinstellungen",
    i18Id: "profile.link.notification_settings",
    to: `${route}/privacy`,
  },
  {
    primary: "Nutzungsbedingungen",
    i18Id: "profile.link.terms_of_service",
    to: `${route}/terms`,
  },
  {
    primary: "Datenschutz",
    i18Id: "profile.link.data_privacy",
    to: `${route}/data-privacy`,
  },
  {
    primary: "AGB",
    i18Id: "profile.link.tandc",
    to: `${route}/tandc`,
  },
  {
    primary: "Impressum",
    i18Id: "profile.link.imprint",
    to: `${route}/imprint`,
  },
  {
    primary: "Passwort ändern",
    i18Id: "profile.link.change_password",
    to: UpdatePasswordContainer.route,
  },
  {
    primary: "Logout",
    i18Id: "profile.link.logout",
    action: (dispatch) => dispatch(logoutUser()),
  },
];

const useStyles = makeStyles((theme) => ({
  profile: {
    marginBottom: theme.spacing(2),
  },
  logo: {
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "15px",
    marginBottom: "20px",
    [theme.breakpoints.down("sm")]: {
      width: "50%",
    },
    width: "75%",
  },
}));

const ProfileContainer = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { formatMessage } = useIntl();
  const currentUser = useAppSelector((state) => state.currentUser);
  const currentEstate = useAppSelector((state) => state.estates.currentEstate);

  const handleItemClick = (item) => {
    if (item.action) {
      item.action(dispatch);
    } else if (item.to) {
      history.push(item.to);
    }
  };

  return (
    <div>
      <AppBar position="static">
        <LocationFilterToolbar noTicketFilter />
      </AppBar>

      <div className={classes.profile}>
        <ProfileHeader estate={currentEstate} />
      </div>

      <div className={classes.profile}>
        <SimpleProfile currentUser={currentUser} />
      </div>

      <Paper sx={{ m: 2, overflow: "hidden" }}>
        <List sx={{ backgroundColor: "background.paper", padding: 0 }}>
          {profileContent.map((item) => {
            const listItemOptions = {};

            if (item.to && !item.action) {
              listItemOptions.to = item.to;
              listItemOptions.component = Link;
            } else {
              listItemOptions.button = true;
              listItemOptions.onClick = () => handleItemClick(item);
            }

            return (
              <ListItem key={item.i18Id} {...listItemOptions} divider>
                <ListItemText primary={formatMessage({ id: item.i18Id })} />
                <ListItemSecondaryAction>
                  <ListItemIcon style={{ minWidth: 0 }}>
                    <KeyboardArrowRight />
                  </ListItemIcon>
                </ListItemSecondaryAction>
              </ListItem>
            );
          })}
        </List>
      </Paper>
      <div className={classes.logo} align="center">
        <img src={bg} alt="hausify logo" />
      </div>
    </div>
  );
};

ProfileContainer.route = route;

export default ProfileContainer;
